import { createAsyncThunk, current } from '@reduxjs/toolkit';
import axios from 'axios';
import { axiosAdmin } from '../../../utils/axiosUser';

export const initStateUserSingle = {
  userSingle: { data: null, loading: false, error: null },
};

export const userSingle = createAsyncThunk('user/userSingle', async (data, { rejectWithValue, fulfillWithValue }) => {
  return await axiosAdmin
    .get(`/user/${data.id}`)
    .then((res) => {
      return fulfillWithValue(res.data);
    })
    .catch((res) => {
      return rejectWithValue(res.response.data);
    });
});

export const reducerUserSingle = {
  [userSingle.pending]: (state) => {
    state.userSingle.loading = true;
  },
  [userSingle.fulfilled]: (state, action) => {
    state.userSingle.loading = false;
    state.userSingle.data = action.payload;
    state.userSingle.error = null;
  },
  [userSingle.rejected]: (state, action) => {
    state.userSingle.data = null;
    state.userSingle.loading = false;
    state.userSingle.error = action.payload;
  },
};
